namespace Umbrella.Modules {
    @Pipe('Umbrella', 'isArray')
    class IsArrayFilter {
        public transform(value: any): boolean {
            return angular.isArray(value);
        }
    }
}
